import React from 'react';
import { createRoot } from 'react-dom/client';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import '@fontsource/ubuntu/300.css';
import '@fontsource/ubuntu/400.css';
import '@fontsource/ubuntu/500.css';
import '@fontsource/ubuntu/700.css';

import App from './App';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.AI_INSTRUMENTATION_KEY,
    disablePageUnloadEvents: ['unload'],
  },
});
appInsights.loadAppInsights();

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((reg) => reg.unregister()))
    .catch(() => {});
}

const container = document.getElementById('root');
createRoot(container).render(
  <React.StrictMode>
    <App appInsights={appInsights} />
  </React.StrictMode>
);
